import React from "react";
import { Grid, Box, Skeleton, Chip } from "@mui/material";

const CatererCardSkeleton = () => {
  return (
    <Grid
      container
      sx={{
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        borderRadius: "12px",
        mt: 2,
        m: "auto",
        flexDirection: { xs: "column", sm: "row" },
        height: { xs: "auto", md: "280px", lg: "260px" },
        overflow: "hidden",
        display: "flex",
        backgroundColor: "#fff",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      {/* Image Section Skeleton */}
      <Grid
        item
        xs={12}
        sm={12}
        md={5}
        lg={5}
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: "fit-content", md: "100%" },
          minHeight: "220px",
        }}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
          sx={{
            borderRadius: { xs: "12px 12px 0 0", sm: "12px 0 0 12px" },
          }}
        />
      </Grid>

      {/* Content Section Skeleton */}
      <Grid
        item
        xs={12}
        sm={12}
        md={7}
        lg={7}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "start",
          p: { xs: 2.5, sm: 2.5, xl: 2.5 },
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
        }}
      >
        <Box sx={{ width: "100%" }}>
          {/* Title and rating */}
          <Skeleton variant="text" width="70%" height={28} />
          <Skeleton variant="text" width="40%" height={20} sx={{ mb: 2 }} />

          {/* Chip */}
          <Skeleton
            variant="rectangular"
            width={100}
            height={24}
            sx={{ mb: 1.5, borderRadius: "6px" }}
          />

          {/* Meal heading */}
          <Skeleton variant="text" width="30%" height={20} sx={{ mb: 1 }} />

          {/* Meal Chips */}
          <Box
            sx={{ display: "flex", gap: 1, flexWrap: "wrap", height: "60px" }}
          >
            {[...Array(2)].map((_, idx) => (
              <Skeleton
                key={idx}
                variant="rectangular"
                width={60}
                height={24}
                sx={{ borderRadius: "4px" }}
              />
            ))}
            <Skeleton
              variant="rectangular"
              width={40}
              height={24}
              sx={{ borderRadius: "4px" }}
            />
          </Box>
        </Box>

        {/* Button */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={40}
          sx={{ borderRadius: "8px", mt: 2 }}
        />
      </Grid>
    </Grid>
  );
};

export default CatererCardSkeleton;
